import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DsAccountService {
  /**
   * The current account id
   */
  private _accountId: number;

  /**
   * Get the current account id.
   *
   * @returns number
   */
  public get accountId(): number {
    return this._accountId;
  }

  /**
   * Set the current account id.
   *
   * @param id number
   */
  public set accountId(id: number) {
    this._accountId = id;
  }
}
